module.exports = __webpack_public_path__ + "img/decorate_unit_cell_icon.png";